import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate, useLocation } from "react-router-dom";
let LeaveRequestView = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={9} md={9} sm={8} xs={4}>
              <BackHeader backHanler={() => navigate(-1)} />{" "}
            </Grid>
            <Grid item xl={2} lg={3} md={3} sm={4} xs={8}>
              <div
                className="student-panel-leave-request-header-button"
                style={{
                  backgroundColor:
                    location.state.status === "Panding"
                      ? "#FFD1B0"
                      : location.state.status === "Accepted"
                      ? "#D2FFEB"
                      : "#FFB0B0",
                  color:
                    location.state.status === "Panding"
                      ? "#B84D00"
                      : location.state.status === "Accepted"
                      ? "#098B51"
                      : "#B80000",
                }}
              >
                {location.state.status}
              </div>
            </Grid>
          </Grid>
        </Box>
        <div className="view-leave-request-data-main">
          <p className="view-leave-request-title">Leave title:</p>
          <p className="view-leave-request-description">
            Nam ac velit eu magna placerat mattis sit amet et velit. Cras
            eleifend ante id aliquam sagittis.
          </p>
        </div>
        <div className="view-leave-request-data-main">
          <p className="view-leave-request-title">Start Date - End Date:</p>
          <p className="view-leave-request-description">
            03-03-2022 - 04-03-2022
          </p>
        </div>
        <div className="view-leave-request-data-main">
          <p className="view-leave-request-title">Leave Description</p>
        </div>
        <p className="view-leave-request-description">
          Dear sir/mam <br />
          <br />
          Nam ac velit eu magna placerat mattis sit amet et velit. Cras eleifend
          ante id aliquam sagittis. Curabitur vitae neque neque. Phasellus et
          feugiat ex. Aenean ultricies est ut dignissim varius. Ut quis lacus
          auctor, faucibus neque scelerisque, tempus nunc. Maecenas consectetur
          purus sit amet nisl pharetra varius. Ut malesuada scelerisque purus,
          quis luctus dolor consectetur vel. Mauris lacinia neque ac ullamcorper
          scelerisque. Vestibulum elementum iaculis ex id ultricies. Phasellus a
          justo dolor. Sed quis ex nec risus mattis volutpat.
          <br />
          <br />
          Best Regards <br />
          David Anderson
        </p>
        {location.state.status === "Rejected" && (
          <div>
            <h1 className="student-panel-view-requeste-reject-heading">
              Institute Reason:
            </h1>
            <p className="student-panel-view-requeste-reject-description">
              Nam ac velit eu magna placerat mattis sit amet et velit. Cras
              eleifend ante id aliquam sagittis.
            </p>
          </div>
        )}
      </div>
    </SideMenu>
  );
};
export default LeaveRequestView;
